<template>
  <div id="app">  
    <div class="website" v-show="started">
      <router-view/> 
    </div>
  </div>
</template>

<script> 
export default {
  data() {
    return  {
      started: true
    }
  },
  components: { 
  },
  mounted() {

  },
  methods: {
    start() {
      this.started = true;
    }
  }
}
</script>

<style>
:root {
  --primary-color: white;
  --secondary-color: #EC4D37;
  --background-color: #030303;
}

a {
  color: var(--secondary-color);
}

* {
  font-family: 'Roboto', sans-serif;
}
body {
  margin: 0;
  padding: 0;
  border: 0;
  overflow:hidden;
}
/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}*/

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.website {
  position: relative;
  height: 100vh;
  width: 100%; 
}
 


/* PER OROLOGIO, LASCIARE QUI, è globale a tutti i canvas creati da hover effect */
.background > canvas {
    position: absolute;
    top: 0;
    left: 0;
}

/*Testo2*/
.vue-typer {
  font-family: 'Hammersmith One', sans-serif;
  /* font-size: 30px; */
  text-align: center;
  margin:0;
  height: 100%;
  /* top: 25%; */
  /* padding: 0 10%; */
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
}

.vue-typer .custom.char.typed {
  color:var(--primary-color)!important;
  text-align: center;
  margin:0;

}

.typed{
  color: var(--primary-color);
}

.vue-typer .custom.caret {
  display: none;
}

.vue-typer .custom.char.selected {
  background-color: transparent;
}


</style>
